import React,{ useState } from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import OutboundOutlinedIcon from '@mui/icons-material/OutboundOutlined';
import TimelapseOutlinedIcon from '@mui/icons-material/TimelapseOutlined';
import MoreTimeOutlinedIcon from '@mui/icons-material/MoreTimeOutlined';
import SmsFailedOutlinedIcon from '@mui/icons-material/SmsFailedOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { ReactComponent as LogIQmindIcon } from 'assets/img/LogIQmindIcon.svg';
import { Icon, SvgIcon } from '@mui/material';
import { PortalNames } from "common/Portals";
import { Utils } from 'common/Utils';

export var SidebarData = {
    getItems: (userInfo) => {
        var sidebarItems = [];

        var companySidebar = userInfo?.companyDetails?.sidebarItems;
        if (companySidebar && companySidebar.find(s => s.portal == "Employer")) {
            sidebarItems = companySidebar.find(s => s.portal == "Employer").items
                .map(i => {
                    return {
                        title: i.title,
                        link: (i.link.startsWith('/') ? `/${PortalNames.Employer.Path}${i.link}` : i.link),
                        index: i.index,
                        icon: i.isSVGIcon ? <SvgIcon><img src={`assets/img/${i.icon}.svg`} /></SvgIcon>
                            : <Icon baseClassName='material-icons-outlined'>{i.icon}</Icon>,
                        isExternalLink: !i.link.startsWith('/'),
                    };
                });
        }
        else {
        
            var isBroker = Utils.isBroker(userInfo);
            var groupType = userInfo?.companyDetails?.groupType ?? "";

            sidebarItems.push({
                title: "Dashboard",
                icon: <DashboardOutlinedIcon />,
                link: `/${PortalNames.Employer.Path}/dashboard`,
                index: 1,
            });

            sidebarItems.push({
                title: "Important AXIM Messages",
                icon: <MessageOutlinedIcon />,
                link: `/${PortalNames.Employer.Path}/messages`,
                index: 2,
            });

            sidebarItems.push({
                title: "Employee",
                icon: <ContactsOutlinedIcon />,
                link: `/${PortalNames.Employer.Path}/employee`,
                index: 3,
            });

            if (!isBroker) {
                sidebarItems.push({
                    title: "Files",
                    icon: <DescriptionOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/files`,
                    index: 5,
                });
            }

            if (groupType !== "GSG") {
                sidebarItems.push({
                    title: "Time Sheets",
                    icon: <QueryBuilderOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/time-sheets`,
                    index: 6,
                });
            }

            if (groupType !== "GSG") {
                sidebarItems.push({
                    title: "H&W Statement",
                    icon: <HowToRegOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/hw-statement`,
                    index: 7,
                });
            }

            if (!isBroker) {
                sidebarItems.push({
                    title: "Uploads",
                    icon: <PublishOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/uploads`,
                    index: 8,
                });
            }
            
            if (groupType !== "GSG" && !isBroker) {
                sidebarItems.push({
                    title: "Hours File Manager",
                    icon: <MoreTimeOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/hours-file`,
                    index: 9,
                });
            }

            if (groupType !== "GSG" && !isBroker) {
                sidebarItems.push({
                    title: "Reports",
                    icon: <ShowChartOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/reports`,
                    index: 10,
                });
            }

            sidebarItems.push({
                title: "Accounting",
                icon: <PaymentsOutlinedIcon />,
                link: `/${PortalNames.Employer.Path}/accounting`,
                index: 11,
            });

            if (groupType !== "GSG") {
                sidebarItems.push({
                    title: "Excess Allocation",
                    icon: <OutboundOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/excess-allocation`,
                    index: 12,
                });
            }
            
            if (groupType !== "GSG") {
                sidebarItems.push({
                    title: "Hourbank",
                    icon: <TimelapseOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/hourbank`,
                    index: 13,
                });
            }

            if (!isBroker) {
                sidebarItems.push({
                    title: "Settings",
                    icon: <SettingsOutlinedIcon />,
                    link: `/${PortalNames.Employer.Path}/settings`,
                    index: 15,
                });
            }

            // if (!isBroker && groupType !== "GSG") {
            //     sidebarItems.push({
            //         title: "Contracts",
            //         icon: <WorkOutlineOutlinedIcon />,
            //         link: `/${PortalNames.Employer.Path}/contracts`,
            //     });
            // }

            sidebarItems.push({
                title: "BRD",
                icon: <AssignmentOutlinedIcon />,
                link: `/${PortalNames.Employer.Path}/brd`,
                index: 16,
            });

            sidebarItems.push({
                title: "LogIQmind Reports",
                icon: <SvgIcon>
                        <LogIQmindIcon />
                    </SvgIcon>,
                link: `/${PortalNames.Employer.Path}/logiqmind-reports`
            });
        }

        sidebarItems = sidebarItems.sort((a,b) => a.index - b.index);

        return sidebarItems;
    }
}
